import { render } from "./RewardPopUp.vue?vue&type=template&id=d7ad0976&scoped=true"
import script from "./RewardPopUp.vue?vue&type=script&lang=js"
export * from "./RewardPopUp.vue?vue&type=script&lang=js"

import "./RewardPopUp.vue?vue&type=style&index=0&id=d7ad0976&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7ad0976"]])

export default __exports__